export const ANALYICS_FOR_SOCIAL_MEDIA = 'analytics_for_social_media_profile';
export const ANALYTICS_FOR_LOCATION = 'analytics_for_location';
